// extracted by mini-css-extract-plugin
export var numpadContainer = "_mr-1";
export var phoneButton = "_mr-0";